
import React from "react";
import { Page, View, Text, Image, StyleSheet } from "@react-pdf/renderer";
import { PDF_PAGE } from "../../constants/pdfSizes";
import defaultCover from "../../assets/inclusionBg.jpg";


const styles = StyleSheet.create({
  page: {
    width: PDF_PAGE.width,
    height: PDF_PAGE.height,
    position: "relative",
    backgroundColor: "#000",
  },
  background: {
    position: "absolute",
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  overlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,2,0.40)",
  },
  container: {
    flex: 1,
    padding: 40,
    flexDirection: "column",
    justifyContent: "flex-start",
  },
  title: {
    fontFamily: "Montserrat",
    fontSize: 44,
    textAlign: "left",
    color: "#fff",
    fontWeight: "medium",
    marginBottom: 30,
    textShadow: "1px 1px 2px #000",
  },
  listItem: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 14,
  },
  bulletIcon: {
    width: 12,
    height: 12,
    marginRight: 10,
    marginTop: 4,
  },
  listText: {
    fontSize: 16,
    color: "#fff",
    fontFamily: "Montserrat",
    lineHeight: 1.4,
    flex: 1,
    fontWeight: "medium",
    textShadow: "0px 0px 10px #000",
  },
  bullet: {
    fontSize: 18,
    color: "#fff",
    marginRight: 10,
    marginTop: -2,
    textShadow: "1px 1px 2px #000",
  },
});

const InclusionSlide = ({
  bg,
  heading = "INCLUSIONS",
  inclusions = [],
}) => {
  const backgroundImage = bg || defaultCover;
  return (
    <Page size={PDF_PAGE} style={styles.page}>
      <Image src={backgroundImage} style={styles.background} />
      <View style={styles.overlay} />

      <View style={styles.container}>
        <Text style={styles.title}>{heading}</Text>

        {inclusions.map((item, idx) => (
          <View style={styles.listItem} key={idx}>
            <Text style={styles.bullet}>•</Text>
            <Text style={styles.listText}>{item}</Text>
          </View>
        ))}
      </View>
    </Page>
  );
};

export default InclusionSlide;
